const WobDownAggregators = [
  'https://w3id.org/rec#address',
  'https://w3id.org/rec#geometry',
  'https://w3id.org/rec#area',
  'https://w3id.org/rec#lastKnownValue',
  // 'https://w3id.org/rec#hasPoint',
]

const WobUpAggregators = [
  // TODO removed, since entries cannot be aggregated easily as they are not leaves.
  // 'https://webofbuildings.com/ontology/isEntryOf',
  // 'https://w3id.org/rec#locatedIn',
  // 'https://w3id.org/rec#isPointOf',
]

const WobAggregators = [...WobDownAggregators, ...WobUpAggregators]

export { WobAggregators, WobDownAggregators, WobUpAggregators }
